import { Information } from '@carbon/icons-react';

interface LabelWithInfoProps {
  label: string;
  tooltip: string;
}

export function LabelWithInfo({ label, tooltip }: LabelWithInfoProps) {
  return (
    <span className="create-edit-payment-scheme__form__installment__label-with-info">
      {label}
      <span
        title={tooltip}
        className="create-edit-payment-scheme__form__installment__label-with-info__icon-wrapper"
      >
        <Information
          size={16}
          className="create-edit-payment-scheme__form__installment__label-with-info__icon"
        />
      </span>
    </span>
  );
}
